<template v-if="certificate && certificate.type">
  <INECertificationTemplate
    v-if="isINECertificate"
    :certificate="certificate"
    ref="certBody"
  />
  <CertificationTemplate
    v-else
    :certificate="certificate"
    :type="certificateType"
    ref="certBody"
  />
</template>

<script>
import CONSTANTS from '@/constants'
import { mapState } from 'vuex'
import CertificationTemplate from '@/components/certificates/CertificationTemplate.vue'
import INECertificationTemplate from '@/components/certificates/INECertificationTemplate.vue'

export default {
  name: 'Certificate',
  components: {
    INECertificationTemplate,
    CertificationTemplate,
  },
  computed: {
    ...mapState({
      certificate: state => state.certifications.currentCertificate,
    }),

    isINECertificate() {
      return this.certificate.type === CONSTANTS.CERTIFICATES.TYPES.INE
    },
    certificateType() {
      return this.certificate.type || ''
    },
  },
}
</script>

<style lang="scss" scoped></style>
